__turbopack_context__.v({
  "appear-slide-left": "Header-module-scss-module__wS1-Va__appear-slide-left",
  "bounceTwice": "Header-module-scss-module__wS1-Va__bounceTwice",
  "burgerBtn": "Header-module-scss-module__wS1-Va__burgerBtn",
  "fade-in-bottom": "Header-module-scss-module__wS1-Va__fade-in-bottom",
  "fade-in-left": "Header-module-scss-module__wS1-Va__fade-in-left",
  "fade-in-right": "Header-module-scss-module__wS1-Va__fade-in-right",
  "fadeIn": "Header-module-scss-module__wS1-Va__fadeIn",
  "header": "Header-module-scss-module__wS1-Va__header",
  "header--hidden": "Header-module-scss-module__wS1-Va__header--hidden",
  "loader": "Header-module-scss-module__wS1-Va__loader",
  "logo": "Header-module-scss-module__wS1-Va__logo",
  "puff-in-center": "Header-module-scss-module__wS1-Va__puff-in-center",
  "puff-in-left": "Header-module-scss-module__wS1-Va__puff-in-left",
  "pulse": "Header-module-scss-module__wS1-Va__pulse",
  "pulse-contact": "Header-module-scss-module__wS1-Va__pulse-contact",
  "shake-bottom": "Header-module-scss-module__wS1-Va__shake-bottom",
  "slide-again": "Header-module-scss-module__wS1-Va__slide-again",
  "slide-in-right": "Header-module-scss-module__wS1-Va__slide-in-right",
  "stepContent-entrance": "Header-module-scss-module__wS1-Va__stepContent-entrance",
  "wrapper": "Header-module-scss-module__wS1-Va__wrapper",
});
